import React from "react";
import { SentinelLogo } from "../assets/logos";
import IPInfo from "../components/IPInfo";
import styles from "./styles.module.scss";
import { Link } from "react-router-dom";
import NavLinks from "../components/NavLinks";
import Button, { BTN_VARIANTS } from "../components/Button";
import MenuOpen from "../assets/icons/MenuOpen";
import NavLinksMobile from "../components/NavLinks/NavLinksMobile";

const Header = () => {
  const [showLinks, setShowLinks] = React.useState(false);
  const [showIPInfo, setShowIPInfo] = React.useState(true);

  React.useEffect(() => {
    if (showLinks) {
      document.body.style.overflow = "hidden";
      return;
    }
    document.body.style.overflow = "auto";
  }, [showLinks]);

  React.useEffect(() => {
    const handleScroll = () => {
      if (window.innerWidth <= 1000) {
        if (window.scrollY <= 48) {
          setShowIPInfo(true);
        } else {
          setShowIPInfo(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div id="header">
      <IPInfo show={showIPInfo} />
      <section className={styles["main-header"]}>
        <Link title="HOME" to={"/"}>
          <SentinelLogo />
        </Link>
        <section className="hideOnMobile">
          <NavLinks />
        </section>
        {!showLinks && (
          <section className="hideOnDesktop">
            <Button
              variant={BTN_VARIANTS.transparent}
              onClick={() => setShowLinks(!showLinks)}
            >
              <MenuOpen />
            </Button>
          </section>
        )}
      </section>
      {showLinks && <NavLinksMobile onClick={() => setShowLinks(!showLinks)} />}
    </div>
  );
};

export default Header;
